import { spacing, Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"

export function AiAssistantContextSource() {
  const { tPlaceholder } = useTranslate()

  return (
    <div>
      <Text variant="subtitleS" color="secondary" marginBottom={spacing.XS}>
        {tPlaceholder("Source")}
      </Text>
      <Text variant="bodyS" color="secondary">
        {tPlaceholder("Knowledge content")}
      </Text>
    </div>
  )
}
